/* tslint:disable */

/**
 */
export class PartnerAccount {
    password_login?: string;
    id?: number;
    name?: string;
    url_api?: string;
    partner_code?: string;
    username_login?: string;
    company_id?: number;
    public_key?: string;
    private_key?: string;
    description?: string;
    created_at?: string;
    updated_at?: string;
}
